module.exports = __webpack_public_path__ + "media/site/images/products/omms-screen2@2x-4550217661c92d2940314fbf1365891c.png";